module.exports = __webpack_public_path__ + "static/media/banner_l_06.84227fa6.jpg";